import normaliseCompliance from "./complianceNormaliser";

export default function normaliseSustainability(data)
{
    return normaliseCompliance(data);
}